<template>
  <div class="project-one-logo" :style="logoStyles">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 181.1 16.6"
      style="enable-background:new 0 0 181.1 16.6;"
      xml:space="preserve"
    >
      <path
        class="project-one-logo__text"
        d="M7.9,8.9c-1.2,0.7-2.5,1-3.8,0.9H1.5v6H0V0.9h4.1c1.3-0.1,2.7,0.2,3.8,0.9c2,1.4,2.4,4.1,1.1,6.1
			C8.7,8.3,8.3,8.6,7.9,8.9z M6.6,2.6C5.8,2.3,4.9,2.2,4,2.3H1.5v6.2h2.6C4.9,8.5,5.8,8.4,6.6,8C8.1,7.3,8.7,5.5,8,4
			C7.7,3.4,7.2,2.9,6.6,2.6L6.6,2.6z"
      />
      <path
        class="project-one-logo__text"
        d="M23.6,10.2l4.2,5.5h-1.9l-5-6.7C22,9.1,23,9,24.1,8.8c1.4-0.4,2.4-1.7,2.4-3.1c0-1.2-0.6-2.2-1.6-2.8
			C24,2.4,23,2.2,22,2.3h-2.6v13.5H18V0.9h3.8c1.2-0.1,2.5,0.1,3.6,0.6C27,2.3,28,3.9,28,5.7C28,8.2,26,10.2,23.6,10.2z"
      />
      <path
        class="project-one-logo__text"
        d="M43.8,16c-4.2,0.2-7.8-3.2-7.9-7.4s3.2-7.8,7.4-7.9c0.2,0,0.4,0,0.6,0C48,0.5,51.5,3.8,51.7,8
			s-3.2,7.8-7.4,7.9C44.1,16,43.9,16,43.8,16z M43.8,2c-3.5,0-6.3,2.8-6.3,6.3s2.8,6.3,6.3,6.3c3.5,0,6.3-2.8,6.3-6.3
			C50.1,4.9,47.2,2,43.8,2L43.8,2z"
      />
      <path
        class="project-one-logo__text"
        d="M65.1,13.8c-0.6,1.3-2,2.2-3.5,2.1c-2.1,0.1-3.9-1.6-4-3.7c0,0,0,0,0,0H59c0,1.4,1.2,2.5,2.6,2.4
			c2.2,0,2.4-1.8,2.4-3.6V0.9h1.5V11C65.5,12,65.4,12.9,65.1,13.8z"
      />
      <path
        class="project-one-logo__text"
        d="M75.4,15.7V0.9h8.1v1.3h-6.6v5.3h6.4v1.3h-6.4v5.4h6.6v1.3L75.4,15.7L75.4,15.7z"
      />
      <path
        class="project-one-logo__text"
        d="M98.8,16c-4.2,0.2-7.8-3.1-7.9-7.4s3.1-7.8,7.4-7.9c0.2,0,0.4,0,0.6,0c2.2,0,4.3,1,5.8,2.7
			c0.4,0.4,0.7,0.9,0.9,1.4h-1.7C102.7,3,100.8,2,98.7,2c-3.5,0-6.3,2.8-6.4,6.3c0,3.5,2.8,6.3,6.3,6.4c2.1,0,4.1-1,5.3-2.8h1.7
			C104.3,14.4,101.6,16,98.8,16z"
      />
      <path class="project-one-logo__text" d="M117.4,2.3v13.5h-1.5V2.3h-3.4V0.9h8.3v1.3H117.4z" />
      <path
        class="project-one-logo__text"
        d="M162.4,15.7l-8.5-12.7l0,0v12.7h-1.4V1.3h1.9l8,12l0,0v-12h1.4v14.4L162.4,15.7L162.4,15.7z"
      />
      <path
        class="project-one-logo__text"
        d="M173.3,15.7V1.3h7.8v1.3h-6.4v5.2h6.2v1.3h-6.2v5.3h6.4v1.3L173.3,15.7L173.3,15.7z"
      />
    </svg>

    <div class="project-one-logo__colorwheel" />
  </div>
</template>

<script>
export default {
  name: 'ProjectOneLogo',
  props: {
    width: {
      type: Number,
      required: false,
      default: 181,
    },
    /*
      dark mode will set text to white
      if false - sets text to black
    */
    dark: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    logoStyles() {
      return {
        '--o-fill': this.dark ? 'black' : 'white',
        '--fill': this.dark ? 'white' : 'black',
        '--width': `${Math.round(this.width)}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.project-one-logo__text {
  fill: var(--fill);
}
.project-one-logo {
  position: relative;
  width: var(--width);
}
.project-one-logo__colorwheel {
  width: 9.25%;
  height: 100%;
  margin-left: 70.8%;
  position: absolute;
  top: 0;
  background: conic-gradient(
    #02b222,
    #00afd8 45deg,
    #28499c 90deg,
    #cf2b90 135deg,
    #cc0000 180deg,
    #f3a41e,
    #ffff00 300deg,
    #02b222
  );
  border-radius: 50%;
}
.project-one-logo__colorwheel::before {
  content: '';
  background-color: var(--o-fill);
  width: 50%;
  height: 50%;
  transform: translate(50%, 50%);
  border-radius: 50%;
  position: absolute;
}
</style>
